module.exports = __webpack_public_path__ + "img/category-new-released.54f4d5be.png";